import React from "react";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

import {
  InputRadio,
  InputRadioEquip,
  InputRadioFireEquip,
} from "../Parts/InputRadio";
import {
  InputCheckBox,
  InputCheckBoxEquip,
  InputCheckBoxFireEquip,
} from "../Parts/InputCheckBox";
import {
  InputTextField,
  InputTextFieldEquip,
  InputTextFieldFireEquip,
} from "../Parts/InputText";

const CheckFormBase = React.memo(
  ({
    keyPrefix,
    keyMiddle = "",
    num,
    row,
    RadioWrapper,
    CheckBox,
    TextField,
  }) => {
    const prefix = keyMiddle ? `${keyPrefix}_${keyMiddle}` : keyPrefix;

    return (
      <RadioWrapper key_num={`${prefix}_${num}_${row}1`}>
        <Grid container alignItems="center">
          <Grid item xs={3} sx={{ borderLeft: 1, height: 57, borderBottom: 1 }}>
            <FormControlLabel
              value="対象外"
              control={<Radio />}
              label="対象外"
            />
          </Grid>
          <Grid item xs={3} sx={{ borderLeft: 1, height: 57, borderBottom: 1 }}>
            <FormControlLabel
              value="指摘なし"
              control={<Radio />}
              label="指摘なし"
            />
          </Grid>
          <Grid item xs={3} sx={{ borderLeft: 1, height: 57, borderBottom: 1 }}>
            <FormControlLabel
              value="要是正"
              control={<Radio />}
              label="要是正"
            />
          </Grid>
          <Grid item xs={2} sx={{ borderLeft: 1, height: 57, borderBottom: 1 }}>
            <CheckBox key_num={`${prefix}_${num}_${row}2`} />
          </Grid>
          <Grid item xs={1} sx={{ borderLeft: 1, height: 57, borderBottom: 1 }}>
            <TextField key_num={`${prefix}_${num}_${row}3`} />
          </Grid>
        </Grid>
      </RadioWrapper>
    );
  }
);

// 建築物用
export const CheckForm = (props) => (
  <CheckFormBase
    {...props}
    keyPrefix="a51"
    RadioWrapper={InputRadio}
    CheckBox={InputCheckBox}
    TextField={InputTextField}
  />
);

// 設備用
export const CheckFormEquipment = (props) => (
  <CheckFormBase
    {...props}
    keyPrefix="e41"
    keyMiddle={props.type}
    RadioWrapper={InputRadioEquip}
    CheckBox={InputCheckBoxEquip}
    TextField={InputTextFieldEquip}
  />
);

// 消防設備用
export const CheckFormFireEquipment = (props) => (
  <CheckFormBase
    {...props}
    keyPrefix="f41"
    keyMiddle={props.type}
    RadioWrapper={InputRadioFireEquip}
    CheckBox={InputCheckBoxFireEquip}
    TextField={InputTextFieldFireEquip}
  />
);
